/**
 * Minimalerei — Zepto Personalizer Guard
 *
 * Zepto's required-field-validation greift nur wenn Form-Fields im
 * DOM sind — das ist der Fall solange der Editor offen ist
 * (.pplr-c-button trägt dann die Klasse .pplr_remove).
 *
 * Wenn der Editor geschlossen ist (oder nie geöffnet wurde):
 * - Fängt diesen Guard den ATC-Klick im Capture-Phase ab
 * - Blockiert ihn + öffnet stattdessen den Editor
 *
 * Wenn der Editor offen ist → Zepto's eigene Validation übernimmt.
 *
 * Funktioniert auch wenn User Editor öffnet + Reset klickt + ATC
 * klickt (Editor wäre dann wieder zu → wird wieder geblockt).
 */

(function () {
  'use strict';

  const TRIGGER_SELECTOR = '.pplr-c-button';
  const ATC_SELECTOR = '.buy-box__atc';
  const EDITOR_OPEN_SELECTOR = '.pplr-c-button.pplr_remove';
  const PRODUCT_DATA_ID = 'mp-product-data';

  // ============================================================
  // ATC-Guard: ATC-Klick erzwingt Zepto-Editor wenn der nicht offen ist
  // ============================================================
  document.addEventListener('click', function (e) {
    const atc = e.target.closest(ATC_SELECTOR);
    if (!atc) return;
    if (!document.querySelector(TRIGGER_SELECTOR)) return;
    if (document.querySelector(EDITOR_OPEN_SELECTOR)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const openTrigger = document.querySelector('.pplr-c-button:not(.pplr_remove)');
    if (openTrigger) {
      openTrigger.click();
    }
  }, true);

  // ============================================================
  // PersonalisierenStart v2 — First-Party-fbq + Shopify Analytics
  // ============================================================
  // v1 (Commit b72f69d) nutzte Shopify.analytics.publish + Custom-
  // Pixel-Subscriber im Admin. Das Custom-Pixel läuft aber in einer
  // Sandbox-iframe → kein Zugriff auf First-Party-Cookies _fbp/_fbc,
  // deshalb kein Klick-ID-Match in Meta.
  //
  // v2 (dieser Code): Pixel direkt im Storefront nachladen und
  // fbq('trackCustom', ...) ausführen. Dort sind _fbp/_fbc verfügbar,
  // Meta kann das Ereignis einer Anzeige zuordnen.
  //
  // Zustimmung: Pixel wird NUR geladen und NUR gefeuert wenn
  // Shopify.customerPrivacy.marketingAllowed() === true. Die API
  // wird bei Bedarf via Shopify.loadFeatures nachgeladen. Auf
  // nachträgliche Zustimmung via 'visitorConsentCollected'-Event
  // hören (dann wird next click erst scharf).
  //
  // Shopify.analytics.publish('personalisieren_start', ...) bleibt
  // zusätzlich drin — schadet nicht, nützt später für den optionalen
  // CAPI-Server-Pfad (Teil C) über dieselbe event_id.
  //
  // WICHTIG: Nach Live-Push muss Marc das benutzerdefinierte Pixel
  // "Meta – PersonalisierenStart" in Shopify-Admin → Kundenereignisse
  // TRENNEN, sonst doppelte Events (Admin-Pixel + direktes fbq hier).
  //
  // Pixel-ID: 232047587986903.
  // kein fbq('track','PageView') — PageView kommt bereits aus der Meta-App.
  var META_PIXEL_ID = '232047587986903';
  var _fbqReady = false, _fbqLoading = false, _fbqQueue = [];

  function marketingAllowed() {
    try {
      return !!(window.Shopify
        && window.Shopify.customerPrivacy
        && typeof window.Shopify.customerPrivacy.marketingAllowed === 'function'
        && window.Shopify.customerPrivacy.marketingAllowed());
    } catch (err) { return false; }
  }

  function withCustomerPrivacy(cb) {
    if (window.Shopify && window.Shopify.customerPrivacy) { cb(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function () { cb(); }
      );
      return;
    }
    // Shopify-Objekt noch nicht da → kurz polling (max 2s).
    var tries = 0;
    var iv = setInterval(function () {
      if (
        (window.Shopify && window.Shopify.customerPrivacy) ||
        ++tries > 20
      ) {
        clearInterval(iv);
        cb();
      }
    }, 100);
  }

  function ensureFbq(cb) {
    if (!marketingAllowed()) return;
    if (_fbqReady && typeof window.fbq === 'function') { cb && cb(); return; }
    if (cb) _fbqQueue.push(cb);
    if (_fbqLoading) return;
    _fbqLoading = true;

    // Standard Meta-Pixel-Snippet (von Meta vorgegeben, unverändert).
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    window.fbq('set', 'autoConfig', false, META_PIXEL_ID);
    window.fbq('init', META_PIXEL_ID);
    // KEIN fbq('track','PageView') — Meta-App sendet den schon,
    // sonst würden PageViews im Events Manager doppelt landen.

    _fbqReady = true;
    while (_fbqQueue.length) {
      try { _fbqQueue.shift()(); } catch (err) { /* ignore */ }
    }
  }

  // Nachträgliche Zustimmung via Banner: ab jetzt kann nächster
  // Klick das Pixel scharf schalten. Kein Pre-Loading hier — wir
  // laden erst beim ersten echten Event.
  document.addEventListener('visitorConsentCollected', function () {
    // Marker — ensureFbq() im Klick-Handler nutzt dann die neue
    // Zustimmungs-Lage automatisch.
  });

  function readProductData() {
    const el = document.getElementById(PRODUCT_DATA_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      console.warn('[mp-pixel] mp-product-data JSON konnte nicht geparsed werden', err);
      return null;
    }
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.pplr-c-button:not(.pplr_remove)');
    if (!trigger) return;

    const product = readProductData();
    if (!product) return;

    // Session-Dedupe: ein Editor-Open pro Produkt und Besuch.
    // try/catch wegen privatem Modus (sessionStorage kann throwen).
    const key = 'mp_ps_' + product.id;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (err) {
      // Private-Mode: ohne Dedupe weiterfeuern — besser doppelt
      // als nie.
    }

    const eventId =
      'ps_' + product.id + '_' + Date.now() + '_' +
      Math.random().toString(36).slice(2, 8);

    // (1) Shopify Analytics (bleibt — nützt später für CAPI-Server-Pfad
    //     über dieselbe event_id).
    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      window.Shopify.analytics.publish('personalisieren_start', {
        product_id: String(product.id),
        handle: product.handle,
        name: product.name,
        category: product.category,
        value: product.price,
        currency: 'EUR',
        event_id: eventId
      });
    }

    // (2) First-Party-fbq direkt auf der Seite — nur bei Marketing-
    //     Zustimmung. Hier sind _fbp/_fbc verfügbar, Meta kann das
    //     Event einer Anzeige zuordnen (Klick-ID-Match).
    withCustomerPrivacy(function () {
      if (!marketingAllowed()) return;
      ensureFbq(function () {
        window.fbq('trackCustom', 'PersonalisierenStart', {
          content_ids: [String(product.id)],
          content_name: product.name,
          content_type: 'product',
          content_category: product.category,
          value: product.price,
          currency: 'EUR'
        }, { eventID: eventId });
      });
    });
  }, true);

  // ============================================================
  // Variant-Change-Sync: Preis im mp-product-data JSON aktuell halten
  // ============================================================
  // Dawn's product-info.js publisht PUB_SUB_EVENTS.variantChange
  // nachdem die neue Variante geladen ist. Wir hängen uns dort ein
  // und updaten das price-Feld im JSON. So bleibt der gepublishte
  // Pixel-Event-Preis immer synchron zur aktuellen Auswahl.
  //
  // pubsub.js + constants.js werden via defer geladen, daher warten
  // wir bis subscribe/PUB_SUB_EVENTS verfügbar sind.
  function bindVariantChangeSync() {
    if (typeof window.subscribe !== 'function' || !window.PUB_SUB_EVENTS) {
      return false;
    }
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (payload) {
      const variant = payload && payload.data && payload.data.variant;
      if (!variant || typeof variant.price !== 'number') return;
      const el = document.getElementById(PRODUCT_DATA_ID);
      if (!el) return;
      try {
        const obj = JSON.parse(el.textContent);
        obj.price = variant.price / 100;
        el.textContent = JSON.stringify(obj);
      } catch (err) {
        console.warn('[mp-pixel] variant-change JSON update fehlgeschlagen', err);
      }
    });
    return true;
  }

  if (!bindVariantChangeSync()) {
    // Pub-Sub noch nicht geladen → kurz polling, max 2s
    let tries = 0;
    const iv = setInterval(function () {
      if (bindVariantChangeSync() || ++tries > 20) clearInterval(iv);
    }, 100);
  }
})();
